<script lang="ts">
	// Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';

	// Helpers
	import { status_configurator } from 'src/helpers/device_data_helpers';

	// Services and configs
	import { devices_config } from 'src/configs/devices';

	// Components
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import SidepanelStatusPeek from 'src/components/Sidepanel/SidepanelStatusPeek.svelte';

	// Types
	import type { Device } from 'src/types/Device.ts';
	import { createGen1StatusLabels } from '../../SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Shelly/Gen1/gen1-main-helpers';
	import { resolveSidepanelStatusSlots } from 'src/helpers/sidepanel_status_slots';
	import DeviceLabelList from '../DeviceLabelList.svelte';

	export let device: Device;

	$: deviceConfig = devices_config?.[device?.type];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: _statuses = status?.online && deviceConfig ? status_configurator(status, device, settings) : [];
	$: labelList = createGen1StatusLabels(_statuses);
	$: statusSlots = resolveSidepanelStatusSlots(device, _statuses);
	$: showStatusPeek = !!statusSlots.main || statusSlots.peek.length > 0;
</script>

<DeviceViewStateWrapper {device} hideSlotFloatingBottom={!showStatusPeek}>
	<div slot="staticTop">
		{#if !showStatusPeek}
			<DeviceLabelList {labelList} />
		{/if}
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<svelte:fragment slot="floatingBottom">
		{#if showStatusPeek}
			<SidepanelStatusPeek main={statusSlots.main} peek={statusSlots.peek} />
		{/if}
	</svelte:fragment>
</DeviceViewStateWrapper>
